// Delivery actions consts
export const DELIVERY_LOAD_ITEMS = 'DELIVERY_LOAD_ITEMS';
export const DELIVERY_CALC_ORDER = 'DELIVERY_CALC_ORDER';
export const DELIVERY_UPDATE_STATE = 'DELIVERY_UPDATE_STATE';
export const DELIVERY_RESET_STATE = 'DELIVERY_RESET_STATE';
export const DELIVERY_SETUP_ORDER = 'DELIVERY_SETUP_ORDER';
export const DELIVERY_CLEAR_BASKET = 'DELIVERY_CLEAR_BASKET';

// Login actions consts
export const LOGIN_UPDATE_STATE = 'LOGIN_UPDATE_STATE';
export const LOGIN_RESET_STATE = 'LOGIN_RESET_STATE';
// Aboutus actions consts
export const ABOUTUS_UPDATE_STATE = 'ABOUTUS_UPDATE_STATE';
export const ABOUTUS_RESET_STATE = 'ABOUTUS_RESET_STATE';

// Register first step consts
export const REGISTER_FIRST_UPDATE_STATE = 'REGISTER_FIRST_UPDATE_STATE';
export const REGISTER_FIRST_RESET_STATE = 'REGISTER_FIRST_RESET_STATE';
export const REGISTER_FIRST_SETUP_USER = 'REGISTER_FIRST_SETUP_USER';

// Register second step consts
export const REGISTER_SECOND_UPDATE_STATE = 'REGISTER_SECOND_UPDATE_STATE';
export const REGISTER_SECOND_SETUP_USER = 'REGISTER_SECOND_SETUP_USER';
export const REGISTER_SECOND_RESET_STATE = 'REGISTER_SECOND_RESET_STATE';

// My Orders consts
export const MYORDERS_UPDATE_STATE = 'MYORDERS_UPDATE_STATE';
export const MYORDERS_LOAD_ORDERS = 'MYORDERS_LOAD_ORDERS';
export const MYORDERS_VIEW_ORDER = 'MYORDERS_VIEW_ORDER';
export const MYORDERS_RESET_STATE = 'MYORDERS_RESET_STATE';
export const MYORDERS_RATE_DELIVERY = 'MYORDERS_RATE_DELIVERY';

// Profile consts
export const PROFILE_UPDATE_STATE = 'PROFILE_UPDATE_STATE';
export const PROFILE_LOGOUT = 'PROFILE_LOGOUT';

// Profile consts
export const OFFERS_UPDATE_STATE = 'OFFERS_UPDATE_STATE';
export const OFFERS_RESET_STATE = 'OFFERS_RESET_STATE';

// Settings consts
export const SETTINGS_UPDATE_STATE = 'SETTINGS_UPDATE_STATE';
export const SETTINGS_RESET_STATE = 'SETTINGS_RESET_STATE';

// Notifications consts
export const NOTIFICATIONS_UPDATE_STATE = 'NOTIFICATIONS_UPDATE_STATE';
export const NOTIFICATIONS_RESET_STATE = 'NOTIFICATIONS_RESET_STATE';

//DRIVER consts
export const UPDATE_INVOICE_ITEMS = 'UPDATE_INVOICE_ITEMS';
export const RESET_INVOICE_ITEMS = 'RESET_INVOICE_ITEMS';
